import React, { Fragment, useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';

import { Container, Row, Col, Button, Input, Label, Card, CardBody, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getPaymentReporDetail, updatePaymentReport } from "crud/payment.crud";
import weaverOverlay from "../../assets/images/weaver_overlay.png"
import Util from "pages/Dashboard/Common/Util";
import Modal from "components/RopikCustom/Modal_v2";
import { Link, useLocation, useHistory } from "react-router-dom"
import moment from "moment";


const InvoicingManagementDetails = () => {
  const location = useLocation()
  const history = useHistory()
  const [inputItem, setInputItem] = useState({})
  const [modalShow, setModalShow] = useState({
    reissue: false,
  })
  const [data, setData] = useState([]);
  const [dataList, setDataList] = useState([]);
  

  const getDataList = async () => {
    try {      
      const params = {        
        id: location.state?.id || '',
      }
      const rs = await getPaymentReporDetail(params);
      console.log(rs.data)
      setData(rs?.data?.data)
      setDataList(rs?.data?.data?.history_list)        
      
    } catch (e) {
      
    }    
  }

  
  const saveData = async () => {
    try {      
      const params = {        
        id: location.state?.id || '',
        qty : inputItem?.qty || 0,
        qty_type : data?.contract?.collect_type || 'l',
        total_price : inputItem?.price || 0,
        total_payment_price : data?.total_payment_price - ( (data?.total_price || 0) - (inputItem?.price || 0)),
        type : 'collect',
        memo : inputItem?.memo
      }
      const rs = await updatePaymentReport(params);      
      getDataList()   
      modalClose('reissue')
    } catch (e) {
      
    }    
  }


  const modalOpen = (key) => {
    setModalShow(prev => ({...prev, [key] : true}))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({...prev, [key] : false}))
  }

  const changeInputCondition = (key, value) => {
    setInputItem(prev => ({...prev, [key]: value}))
  }

  useEffect(() => {
    getDataList()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>청구서 발행관리-상세 | 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs maintitle="Home" title="정산관리" breadcrumbItem="청구서 발행관리" />

          <Row>
            <Col xl={5} lg={12}>
              <div className="d-flex justify-content-center w-100">
                <div className="bill-mock-up">
                  <div className="header">
                    <p className="header-text">{moment(data?.report_date).format('YYYY')+'년 '+moment(data?.report_date).format('MM')+'월 청구서'}</p>
                  </div>
                  <div className="main-banner">
                    <div className="text-container">
                      <p className="banner-main-text">스마트<br /><span>수거 플랫폼</span></p>
                      <p className="banner-sub-text">Smart Food Waste Collection Platform</p>
                    </div>
                    <img className="logo" src={weaverOverlay} />
                  </div>
                  <p className="company">{data?.company_to?.name}</p>
                  <div className="charge-box margin-top-9">
                    <div className="d-flex align-items-end">
                      <p className="charge">청구 금액</p>
                      <p className="payment-date">(결제일: {data?.report_date && moment(data?.report_date).format('MM월 DD일')})</p>
                    </div>
                    <div className="charge-container">
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="all-charge-text">총 청구금액</p>
                        <div className="white-value-box">
                          <p className="box-text all-charge-box-text">{Util.setCommaPrice(data?.total_payment_price || 0)}</p>
                        </div>
                      </div>
                      <p className="explanation">청구금액은 수거된 폐기물의 양을 기준으로 합니다.</p>
                    </div>
                    <div className="charge-container">
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="month-charge-text">금월 청구금액</p>
                        <div className="white-value-box">
                          <p className="box-text">{Util.setCommaPrice(data?.total_price || 0)}</p>
                        </div>
                      </div>
                    </div>
                    <div className="charge-container">
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="unpaid-text">미납금액</p>
                        <div className="white-value-box">
                          <p className="box-text">{Util.setCommaPrice(data?.prev_price || 0)}</p>
                        </div>
                      </div>
                    </div>
                    <div className="line line-1"></div>
                    <div className="line line-2"></div>
                  </div>
                  <div className="charge-box margin-top-12">
                    <div className="d-flex align-items-end">
                      <p className="charge">수거현황</p>
                    </div>
                    <div className="charge-container">
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="all-charge-text">금월 / {data?.contract?.collect_type == 'l' ? 'ℓ' : 'kg'}</p>
                        <div className="white-value-box">
                          <p className="box-text">{Util.setCommaPrice(data?.contract?.collect_type == 'l' ? data?.qty_l : data?.qty)}</p>
                        </div>
                      </div>
                    </div>
                    <div className="charge-container margin-top-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <p className="all-charge-text">전월 / {data?.contract?.collect_type == 'l' ? 'ℓ' : 'kg'}</p>
                        <div className="white-value-box">
                          <p className="box-text last-month-box-text">{Util.setCommaPrice(data?.prev_month_qty)}</p>
                        </div>
                      </div>
                    </div>
                    <div className="line line-3"></div>
                  </div>
                  <p className="payment-request">※ 기한 내 납부를 부탁 드립니다.</p>
                  <div className="payment-button">
                    <p>청구금액 납부하기</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col xl={7} lg={12}>
              <p className="font-weight-bold font-size-15 mb-2">청구내역 수정 및 청구서 재발행</p>
              <Card className="mb-0">
                <CardBody className="padding-0">
                  <table className="input-table">
                    <tbody>
                      <tr>
                        <td className="w-10 padding-left-8 primary-bg white-text">사업장명(상호2)</td>
                        <td className="w-15">{data?.company_to?.name}{data?.company_to?.name2 && `(${data?.company_to?.name2})`}</td>
                        <td className="w-10 padding-left-8 primary-bg white-text">사업자번호 검색</td>
                        <td className="w-15">{data?.company_to?.company_number}</td>
                      </tr>
                      <tr>
                        <td className="w-10 padding-left-8 primary-bg white-text">금월 청구 금액</td>
                        <td className="w-15">
                          <input className='waver-input-box w-100 border-radius-0' value={inputItem.monthCharge} placeholder="금월 청구 금액" onChange={(e) => {
                            changeInputCondition('price', e.target.value)
                          }} />
                        </td>
                        <td className="w-10 padding-left-8 primary-bg white-text">금월 수거 현황 ({data?.contract?.collect_type == 'l' ? 'ℓ' : 'kg'})</td>
                        <td className="w-15">
                          <input className='waver-input-box w-100 border-radius-0' value={inputItem.monthCollection} placeholder=">금월 수거 현황 (ℓ)" onChange={(e) => {
                            changeInputCondition('qty', e.target.value)
                          }} />
                        </td>
                      </tr>
                      <tr>
                        <td className="w-10 padding-left-8 primary-bg white-text">● 청구서 재발행 사유</td>
                        <td colSpan={3} className="w-15">
                          <textarea className="waver-text-box w-100 font-size-12 border-radius-0" placeholder="거래처 메모" value={inputItem.reason}
                          onChange={(e)=>{
                            changeInputCondition('memo', e.target.value);
                          }} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
              <div className="d-flex justify-content-between margin-top-10">
                <p>※ 주의사항<br />
                ㆍ청구금액 변경 및  금월 수거량 변경 시 청구서를 재발행 해야 합니다.<br />
                ㆍ청구서 재발행 시 “청구서 재발행 사유”는 필수로 입력해 주셔야 합니다.</p>
                <div className="d-flex">
                  <button style={{ width: 166, height: 29 }} type="button" className="custom-btn border-radius-0 margin-right-4 font-size-15 line-height-1 secondary-bg white-text border-none" onClick={() => {
                    modalOpen('reissue')
                  }}>
                    청구서 재발행
                  </button>
                  <button style={{width: 80, height: 29}} className="custom-btn border-radius-0 font-size-11 line-height-1 button-border secondary-text white-bg margin-right-0" onClick={() => {
                    history.go(-1)
                  }}>목록으로</button>
                </div>
              </div>
              <p className="font-weight-bold font-size-15 mb-2 margin-top-20">청구서 재발행 기록</p>
              <Card className="mb-0">
                <CardBody className="padding-0">
                  <div className="table-responsive">
                    <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                      <thead className="chart-thead">
                        <tr>
                          <th scope="col">No</th>
                          <th scope="col">금월 청구금액</th>
                          <th scope="col">금월 수거 현황({data?.contract?.collect_type == 'l' ? 'ℓ' : 'kg'})</th>
                          <th scope="col">청구서 발행일</th>
                          <th scope="col">청구서 재발행 사유</th>
                        </tr>
                      </thead>
                      <tbody className="chart-tbody">
                        {dataList.map((item, index) => {
                          return (
                            <tr key={item.id + '_' + index}>
                              <td>{dataList.length - index}</td>
                              <td>{item.total_price}</td>
                              <td>{item.qty}</td>
                              <td>{moment(item.created_at).format('YYYY-MM-DD')}</td>
                              <td>{item.memo}</td>
                            </tr>
                          )
                        })}
                        {dataList.length === 0 &&
                          <tr>
                            <td scope="row" colSpan="14">데이터가 없습니다.</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

        </Container>
      </div>

      <Modal
        title={'청구서 재발행'}
        show={modalShow.reissue}
        onHide={() => {
          modalClose('reissue')
        }}
        size="md"
        bodyChildren={
          <Fragment>
            <p>청구금액 및 금월 수거량을 수정합니다. 수정을 반영할 경우<br />정산 금액이 변경 됩니다.</p>
            <p className="mb-0">정말 청구서를 재발행 하시겠습니까?</p>
          </Fragment>
        }
        footerChildren={
        <div className="d-flex justify-content-end">
          <button style={{width: 'auto'}} type="button" className="waves-effect custom-btn active btn btn-dark-gradient btn-sm" onClick={() => {
            saveData()
          }}>
            확인
          </button>
          <button style={{width: 'auto'}} type="button" className="waves-effect custom-btn active btn btn-white-border btn-sm" onClick={() => {
            modalClose('reissue')
          }}>
            취소
          </button>
        </div>
        }
      >
      </Modal>
    </React.Fragment>
  )
}

export default InvoicingManagementDetails
